import { generalApiRequest } from "../api/apiIndex";

export async function get_setting(seeting_key) {
  const link = `get_setting/${seeting_key}`;
  const setting = await generalApiRequest(link, "GET", {}, 1);
  return setting.data;
  //   try {
  //     const setting = await generalApiRequest(link, "GET", {}, 1);
  //     return setting.data;
  //   } catch (error) {
  //     console.error("Error fetching setting:", error);
  //   }
}

export function open_service(is_invoice, is_paid, setting) {
  console.log("is invoice " + is_invoice);
  console.log("is paid " + is_paid);
  console.log("setting " + setting);

  if (is_invoice == null || parseInt(is_paid, 10) == 1) {
    return true;
  } else {
    console.log("getting to else");

    if (parseInt(is_invoice, 10) != 1 && parseInt(is_paid, 10) != 1) {
      const rtn = setting == 1 ? false : true;
      return rtn;
    }else{
        return true;
    }
  }
}
